import {
  GET_AUDITTRAIL_META,
  GET_AUDITTRAIL_LIST,
  GET_AUDITTRAIL_DETAILS,
} from "resources/actionTypes";

// Meta
export function getAuditTrailMeta() {
  return {
    type: GET_AUDITTRAIL_META.GET_AUDITTRAIL_META_REQUESTED,
  };
}

export function clearAuditTrailMeta() {
  return {
    type: GET_AUDITTRAIL_META.GET_AUDITTRAIL_META_RESET,
  };
}

// List
export function getAuditTrailList(payloadData) {
  return {
    type: GET_AUDITTRAIL_LIST.GET_AUDITTRAIL_LIST_REQUESTED,
    payload: payloadData,
  };
}

export function clearAuditTrailList() {
  return {
    type: GET_AUDITTRAIL_LIST.GET_AUDITTRAIL_LIST_RESET,
  };
}

// Details
export function getAuditTrailDetails(payloadData) {
  return {
    type: GET_AUDITTRAIL_DETAILS.GET_AUDITTRAIL_DETAILS_REQUESTED,
    payload: payloadData,
  };
}

export function clearAuditTrailDetails() {
  return {
    type: GET_AUDITTRAIL_DETAILS.GET_AUDITTRAIL_DETAILS_RESET,
  };
}
